import React from 'react'
// import axios from 'axios'
import { format } from 'date-fns'
import { Button } from 'reactstrap'
import { Modal } from 'antd';

import { If, Then, Switch, Case } from 'react-if'
import { FaCheck, FaTimes } from "react-icons/fa";
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { RejectLeaveReqAPI, ApproveLeaveReqAPI } from '../functions/ApprovePage'

const AllowSelectedApprove = ({ isOpen, isModalVisible, checkedState }) => {

    const MySwal = withReactContent(Swal)
    const { t } = useTranslation()
    const history = useHistory()

    if (!isOpen) {
        return null;
    }

    const handleAllowStatus = async (reason, Status) => {

        if (checkedState.length > 0) {
            checkedState.forEach((d) => {
                if (Status === 'reject') {
                    RejectLeaveReqAPI(d.LEAVE_NO, reason)
                }
                else {
                    ApproveLeaveReqAPI(d.LEAVE_NO, reason)
                }
            })

        }

        isModalVisible(false);
        history.go(0)
    }
    return (
        <>
            <Modal

                title={t("t_approve_reject")}
                centered
                bodyStyle={{
                    backgroundColor: '#f2f7ff',
                }}
                open={isOpen}
                footer={null}
                onCancel={() => { isModalVisible(!isModalVisible) }}
                width={600}
            >
                <div className="content">
                    {
                        checkedState.length > 0 ? (
                            <div className="portlet light bordered">
                                <div className="row g-3">
                                    <ul>
                                        {
                                            checkedState.map((d, index) => {
                                                return (

                                                    <div className="card-content" >
                                                        <div className="card-body">
                                                            <div className='row'>
                                                                <div className='col-sm-4 col-md-2 col-xl-2 col-lg-2'>
                                                                    <Switch>
                                                                        <Case condition={d.STATUS === "-3"}>
                                                                            <span className="badge bg-info" style={{ color: '#fff' }}> {t("t_st_drf")} </span>
                                                                        </Case>
                                                                        <Case condition={d.STATUS === "0"}>
                                                                            <span className="badge bg-warning" style={{ color: '#fff' }}> {t("t_st_ped")} </span>
                                                                        </Case>
                                                                        <Case condition={d.STATUS === "1"}>
                                                                            <span className="badge bg-success" style={{ color: '#fff' }}> {t("t_st_app")} </span>
                                                                        </Case>
                                                                        <Case condition={d.STATUS === "-1"}>
                                                                            <span className="badge bg-danger" style={{ color: '#fff' }}> {t("t_st_can")} </span>
                                                                        </Case>
                                                                        <Case condition={d.STATUS === "-2"}>
                                                                            <span className="badge bg-danger" style={{ color: '#fff' }}> {t("t_st_rej")} </span>
                                                                        </Case>
                                                                    </Switch>
                                                                </div>
                                                                <div className='col-sm-8 col-md-10 col-xl-10 col-lg-10'>
                                                                    <p className="text-title-Announcement">
                                                                        {d.employees.FULL_NAME} : {' '}
                                                                        {
                                                                            d.ALL_DAY_F === "1" ?
                                                                                `${format(new Date(d.BEGIN_DT), 'dd/MM/yyyy')} - ${format(new Date(d.END_DT), 'dd/MM/yyyy')}` :
                                                                                `${format(new Date(d.BEGIN_DT), 'dd/MM/yyyy')} ${d.BEGIN_TIME} - ${d.END_TIME}`
                                                                        }
                                                                    </p>
                                                                    <div className="d-flex justify-content-between">
                                                                        <small className="text-muted label-wrap-reason"> {t("t_reason")} :  {' '}
                                                                            {d.REASON}
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <hr />
                                                        </div>
                                                    </div>

                                                )
                                            })

                                        }

                                    </ul>
                                    <div className="mt-3 d-grid gap-2 d-md-flex justify-content-md-end">
                                        <If condition={checkedState.length > 0}>
                                            <Then>
                                                <Button className="ml-2" color="success" outline
                                                    onClick={async () => {
                                                        await MySwal.fire({
                                                            title: `${t("t_title_approve")}`,
                                                            text: `${t("t_text_approve")}`,
                                                            // icon: 'question',
                                                            input: 'textarea',
                                                            inputPlaceholder: `${t("t_holder_approve")}`,
                                                            showCancelButton: true,
                                                            confirmButtonColor: '#435ebe',
                                                            cancelButtonColor: '#dc3545',
                                                            confirmButtonText: `${t("b_approve")}`,
                                                            cancelButtonText: `${t("b_cancel")}`

                                                        }).then((result) => {
                                                            if (result.isConfirmed) {
                                                                handleAllowStatus(result.value, 'approve')
                                                                MySwal.fire(
                                                                    `${t("t_title_approval")}`,
                                                                    `${t("t_text_approval")}`,
                                                                    'success'
                                                                )
                                                            }
                                                        })
                                                    }}
                                                >
                                                    <FaCheck /> {t("b_approve")}
                                                </Button>

                                                <Button className="ml-2" color="danger" outline
                                                    onClick={async () => {
                                                        await MySwal.fire({
                                                            title: `${t("t_title_reject")}`,
                                                            text: `${t("t_text_reject")}`,
                                                            // icon: 'question',
                                                            input: 'textarea',
                                                            inputPlaceholder: `${t("t_holder_reject")}`,
                                                            showCancelButton: true,
                                                            confirmButtonColor: '#435ebe',
                                                            cancelButtonColor: '#dc3545',
                                                            confirmButtonText: `${t("b_reject")}`,
                                                            cancelButtonText: `${t("b_cancel")}`

                                                        }).then((result) => {
                                                            if (result.value === '') {
                                                                MySwal.fire(`${t("t_req_reason")}`)
                                                            }
                                                            else if (result.isConfirmed) {
                                                                handleAllowStatus(result.value, 'reject')
                                                                MySwal.fire(
                                                                    `${t("t_title_rejected")}`,
                                                                    `${t("t_text_rejected")}`,
                                                                    'success'
                                                                )
                                                            }
                                                        })
                                                    }}
                                                >
                                                    <FaTimes /> {t("b_reject")}
                                                </Button>
                                            </Then>
                                        </If>
                                    </div>
                                </div>
                            </div>
                        ) : (

                            <div className="card-content" >
                                <div className="card-body">
                                    <p className="text-title-Announcement">{t("t_no_data")}</p>
                                </div>
                            </div>

                        )
                    }
                </div>

            </Modal>
        </>
    )
}

export default AllowSelectedApprove